import {Component} from '@angular/core';
import {AuthenticationService} from "../services/authentication.service";
import {RegistrationService} from "../services/registration.service";
import {User} from "../models/user";
import {Registration} from "../models/registration";
import {NgIf, SlicePipe} from "@angular/common";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-profile-page',
  templateUrl: './profile-page.component.html',
  styleUrls: ['./profile-page.component.css'],
  imports: [
    NgIf,
    SlicePipe,
    RouterLink
  ],
  standalone: true
})
export class ProfilePageComponent {
  registerCounter: number = 0;
  user!: User;
  registrations!: Registration[];

  constructor(
    public authService: AuthenticationService,
    private regService: RegistrationService
  ) {}

  async ngOnInit() {
    this.user = await this.authService.getUser();
    this.regService.getRegistrationsByUser(this.user.uid).subscribe(data => {
      this.registrations = data;
      this.registerCounter = this.registrations.length;
    });
  }

  signOut() {
    this.authService.signOut();
  }
}
